import { SimpleGrid } from "@mantine/core";
import InfoArea, { type IInfoAreaProps } from "./InfoArea";

interface IDualInforAreaProps {
  leftArea: IInfoAreaProps;
  rightArea: IInfoAreaProps;
  className?: string;
}

const DualInfoArea: React.FC<IDualInforAreaProps> = ({
  leftArea,
  rightArea,
  className,
}) => {
  const base = "!m-0 !pt-10 xs:px-10 xs:py-5 pb-0 w-full !max-w-none !mx-0";

  return (
    <SimpleGrid
      cols={{
        base: 1,
        md: 2,
      }}
      spacing={{ base: 20, xl: 70 }}
      className={`w-full ${className}`}
    >
      <InfoArea
        fullWidth={false}
        {...leftArea}
        classNames={{
          container: "!max-w-none !mx-0",
        }}
        className={`${base} ${leftArea.className}`}
      />
      <InfoArea
        fullWidth={false}
        {...rightArea}
        classNames={{
          container: "!max-w-none !mx-0",
        }}
        className={`${base} ${rightArea.className}`}
      />
    </SimpleGrid>
  );
};

export default DualInfoArea;
